import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [firstname, setFirstname] = useState("");
  const [surname, setSurname] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault(); // ✅ Prevents the default form submit behavior (page refresh)
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // 💾 Save additional user data in Firestore
      await setDoc(doc(db, "users", user.uid), {
        firstname,
        surname,
        email: user.email,
        createdAt: new Date(),
      });

      window.location.href = "/admin/setup";
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 via-yellow-100 to-blue-100">
      <div className="absolute top-0 left-0 w-full text-center py-6 text-4xl font-extrabold text-pink-600 drop-shadow-sm">
        🎉 Welcome to Festigram 🎉
      </div>

      <form
        onSubmit={handleRegister}
        className="bg-white bg-opacity-90 p-8 pt-16 rounded-2xl shadow-2xl w-full max-w-md border border-pink-200"
      >
        <h2 className="text-3xl font-extrabold text-center text-pink-500 mb-6">
          Create Organizer Account
        </h2>
        {error && (
          <p className="text-red-500 text-sm mb-3 text-center">{error}</p>
        )}

        <input
          type="text"
          placeholder="Firstname"
          className="w-full p-3 border border-pink-300 mb-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-400"
          value={firstname}
          onChange={(e) => setFirstname(e.target.value)}
        />
        <input
          type="text"
          placeholder="Surname"
          className="w-full p-3 border border-pink-300 mb-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-400"
          value={surname}
          onChange={(e) => setSurname(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          className="w-full p-3 border border-pink-300 mb-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-400"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          className="w-full p-3 border border-pink-300 mb-6 rounded-xl focus:outline-none focus:ring-2 focus:ring-pink-400"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 px-6 rounded-xl w-full shadow-md transition duration-200">
          🎁 Register
        </button>

        <p className="mt-4 text-sm text-center text-gray-600">
          Already have an account?{" "}
          <a href="/login" className="text-pink-500 font-medium underline">
            Log in
          </a>
        </p>
      </form>
    </div>
  );
};

export default RegisterPage;
